<template>
  <div class="coal-buttom">
    <div class="coal-list" v-show="btnshow">
      <span
        :class="l == i ? 'a' : 'span'"
        v-for="(item, i) in list"
        :key="i"
        @click="item1(i)"
      >{{ item }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      l: 0,
      list: ["煤矿主场景", "采煤工作面", "掘进工作面"],
      item: 0,
      timer: null
      // btnshow:true,
    };
  },
  mounted() {
    window.change = this.change;
  },
  props: {
    btnshow: Boolean
  },
  methods: {
    item1(i) {
      // 传 到cloab.vue
      console.log(i);
      this.emit.$emit("item", i);
      if (this.item == 0) {
        clearTimeout(this.timer);
        this.timer = null;
        this.l = i;
        // 三维 方法
        document.getElementById("iframe").contentWindow.MMAPI.bottomnav(i);
        this.item = 1;
        this.timer = setTimeout(() => {
          this.item = 0;
        }, 1000);
      }
      if(i == 1||i == 2){
        document.getElementById("iframe").contentWindow.MMSDT.coverage(["wj"], []);
      }
    },
    change(i) {
      // 传 到cloab.vue
      this.emit.$emit("item", i);
      this.l = i;
    }
  }
};
</script>
<style lang="less" scoped>
.coal-buttom {
  width: 100%;
  height: 15%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-image: url("../../assets/x.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  .coal-list {
    width: 40%;
    height: 60%;
    margin-top: 6vh;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .span {
      display: block;
      width: 6vw;
      height: 5vh;
      text-align: center;
      line-height: 5vh;
      font-weight: 900;
      font-size: 0.8vw;
      color: rgb(156, 200, 255);
      cursor: pointer;
    }
  }
}
.a {
  display: block;
  width: 6vw;
  height: 5vh;
  text-align: center;
  line-height: 5vh;
  font-weight: 900;
  font-size: 0.8vw;
  background-image: url(../../assets/backimg.png);
  background-size: 100% 100%;
  color: #fff;
  cursor: pointer;
}
</style>